<template>
  <div style="font-size: 14px; font-weight: 800;">
    <a href="javascript:void(0);" @click="expandAll"><small>Expand</small></a>
    <a style="margin-left: .75em;" href="javascript:void(0);" @click="collapseAll"><small>Collapse</small></a>
    <br>
    <a href="javascript:void(0);" @click="() => { expandAll(); filterType = 'all'; }"><small>Filter All</small></a>
    <a style="margin-left: .75em;" href="javascript:void(0);" @click="() => { expandAll(); filterType = 'incomplete'; }"><small>Filter Incompletes</small></a>
    <a style="margin-left: .75em;" href="javascript:void(0);" @click="() => { expandAll(); filterType = 'complete'; }"><small>Filter Completed</small></a>
    <p style="margin: .75em 0 0;">
      <strong>
        Job Tree
      </strong>
    </p>
    <ul>
      <TreeNode :recyclingJobList="recyclingJobList" :recycling="recycling" :devices="devices" :default-open="isExpanded" v-for="node in data" :key="node.id" :node="node" :tasks="tasks" :type="'location'"/>
    </ul>
  </div>
</template>

<script>
import TreeNode from './JobTreeNode.vue'; // Adjust the path if needed

/**
 * Tree structure with `id`, `units`, `areas`, `devices`, and `tasks` descendent fields.
 * 
 * @component
 * @prop {Array<Object>} tree - The tree structure represented as an array of objects.
 */
export default {
  name: "JobTree",
  components: {
    TreeNode
  },
  data() {
    return {
      isExpanded: false,
      filterType: 'all',
      data: [],
    }
  },
  watch: {
      tree: {
        deep: true,
        handler() {
          this.trimData();
        }
      },
      filterType: {
        deep: true,
        handler() {
          this.trimData();
        }
      }
  },
  methods: {
    trimData() {
      if (this.filterType === 'all') this.data = JSON.parse(JSON.stringify(this.tree));
        if (this.filterType === 'incomplete') {
          this.data = JSON.parse(JSON.stringify(this.tree)).filter(
            (location) => {
              location.units = location.units.filter(
                (unit) => {
                  unit.areas = unit.areas.filter(
                    (area) => {
                      area.devices = area.devices.filter(
                        (device) => {
                          device.states = device.states.filter(
                            (state) => state.taskStatus !== 'Command Success'
                          )
                          return device.states.length > 0;
                        }
                      )
                      return area.devices.length > 0;
                    }
                  )
                  return unit.areas.length > 0
                }
              )
              return location.units.length > 0;
            }
          ); 
        }
        if (this.filterType === 'complete') {
          this.data = JSON.parse(JSON.stringify(this.tree)).filter(
            (location) => {
              location.units = location.units.filter(
                (unit) => {
                  unit.areas = unit.areas.filter(
                    (area) => {
                      area.devices = area.devices.filter(
                        (device) => {

                          device.states = device.states.filter(
                            (state) => state.taskStatus === 'Command Success'
                          )
                          return device.states.length > 0;
                        }
                      )
                      return area.devices.length > 0;
                    }
                  )
                  return unit.areas.length > 0
                }
              )
              return location.units.length > 0;
            }
          ); 
        }
    },
    expandAll() {
      this.isExpanded = false; 
      this.$nextTick(() => {
        this.isExpanded = true;
      });
    },
    collapseAll() {
      this.isExpanded = true;
      this.$nextTick(() => {
        this.isExpanded = false;
      });
    }
  },
  props: {
    tree: {
      type: Array,
      required: true
    },
    tasks: {
      type: Object,
      required: true
    },
    devices: {
      type: Object,
      required: true
    },
    recycling: {
      type: Boolean,
      required: false,
    },
    recyclingJobList: {
      type: Object,
      required: false,
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding-left: 20px;
  margin-bottom: 0;
}

li {
  margin: 10px 0;
}
</style>
